export default __webpack_public_path__ + "static/media/AboutUs.76aee1d0.JPG";